<template>
  <div class="default-modal">
    <el-dialog :model-value="visible" width="35%" top="10%" @close="onClose">
      <div class="dialog-header">
        <span class="header-part">{{ headerText }}</span>
        <el-button size="medium" class="el-white" type="button" plain @click="onClose">
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>

      <div class="popup-date">
        <el-form>
          <el-form-item>
            <label>Choose an option</label>
            <el-select v-model="localOption" placeholder="Select an option" style="width: 100%" @change="onSelect">
              <el-option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
                :label="option.label"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OptionsRejectPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "reject",
    },
  },
  data() {
    return {
      localOption: null,
    };
  },
  computed: {
    isPartialMode() {
      return this.mode === "partial";
    },
    headerText() {
      return this.isPartialMode
        ? "Select an option for this order"
        : "Select an option to reject";
    },
    options() {
      if (this.isPartialMode) {
        return [
          { value: "PARTIAL_ACTIVATE", label: "Partial Activation" },
          { value: "PARTIAL", label: "Partial rejection" },
          { value: "COMPLETE", label: "Full rejection" },
        ];
      }
      return [
        { value: "PARTIAL", label: "Partial rejection" },
        { value: "COMPLETE", label: "Complete rejection" },
      ];
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
      this.localOption = null;
    },
    onSelect(val) {
      if (val === "PARTIAL") {
        this.$emit("partial");
      } else if (val === "COMPLETE") {
        this.$emit("complete");
      } else if (val === "PARTIAL_ACTIVATE") {
        this.$emit("activate");
      }
      this.onClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-part {
  display: flex;
  align-items: center;
  font-weight: 600;
}
</style>


